import React, { forwardRef } from 'react'
import { RowLayout, RowLayoutProps } from './RowLayout'
import { ExpandControls } from './ExpandControls'

const RIGHT = 'ArrowRight'
const LEFT = 'ArrowLeft'

export type ExpandOptions = {
  collapseChannels?: boolean
  checkRule42?: boolean
}

export type ExpandableRowLayoutProps = Omit<
  RowLayoutProps,
  'leftPart' | 'innerRef'
> & {
  id: string
  isExpanded: boolean
  hideChevron?: boolean
  disableExpanding?: boolean
  expandOptions?: ExpandOptions
  onToggleExpand: (id: string, options?: ExpandOptions) => void
}

export const ExpandableRowLayout = forwardRef<any, ExpandableRowLayoutProps>(
  (
    {
      id,
      isExpanded,
      hideChevron,
      disableExpanding,
      onToggleExpand,
      onClick,
      expandOptions,
      ...otherProps
    },
    ref
  ) => {
    let leftPart = null
    if (!hideChevron && disableExpanding) {
      leftPart = <span />
    }
    if (!hideChevron && !disableExpanding) {
      leftPart = (
        <ExpandControls
          id={id}
          onToggleExpand={onToggleExpand}
          isExpanded={isExpanded}
        />
      )
    }

    const handleClick = disableExpanding
      ? onClick
      : (event: React.MouseEvent) => {
          if (
            !event.metaKey &&
            !event.ctrlKey &&
            (otherProps.isActive || !isExpanded || hideChevron)
          ) {
            onToggleExpand(id, expandOptions)
          }
          if (onClick) {
            onClick(event)
          }
        }

    const handleKeyDown = disableExpanding
      ? undefined
      : (event: React.KeyboardEvent<HTMLElement>) => {
          if (event.key === LEFT || event.key === RIGHT) {
            event.preventDefault()
            onToggleExpand(id)
          }
        }

    return (
      <RowLayout
        {...otherProps}
        ref={ref}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        leftPart={leftPart}
      />
    )
  }
)
